const REGEX_PASSWORD = /^(?=.*?[a-zA-Z])(?=.*?\d).+$/
const PASSWORD_MIN = 8
const PASSWORD_MAX = 40

export class Password {
  constructor() {}

  getErrorMessages(password, passwordConfirm) {
    const errorMessages = {}
    try {
      if (password.length < PASSWORD_MIN || PASSWORD_MAX < password.length)
        errorMessages.password = '8文字以上40文字以下でご入力ください'
      else if (!REGEX_PASSWORD.test(password))
        errorMessages.password = '英字と数字の両方を含めてください'

      if (passwordConfirm != password)
        errorMessages.passwordConfirm = 'パスワードが一致しません'

      if (Object.values(errorMessages).filter((v) => v).length)
        throw new Error('入力に不備があります')
    } catch (error) {
      console.error(error)
    }
    return errorMessages
  }
}
